import { useMocks } from '../../shared/env';
import type { EmployeeOnboardingGateway } from './EmployeeOnboardingGateway';
import { HttpEmployeeOnboardingGateway } from './HttpEmployeeOnboardingGateway';
import { MockEmployeeOnboardingGateway } from './MockEmployeeOnboardingGateway';

export const employeeOnboardingGateway: EmployeeOnboardingGateway = useMocks
  ? new MockEmployeeOnboardingGateway()
  : new HttpEmployeeOnboardingGateway();
export type { EmployeeOnboardingGateway } from './EmployeeOnboardingGateway';
